<div [formGroup]="form">
  <div class="flex-row-generic">
    <!-- Account Type Control start-->
    <div class="flex-item-two-columns form-group">
      <label for="{{ baseId }}-account-type">Account Type</label>
      <ap-findcontrol
        id="{{ baseId }}-account-type"
        controlName="AccountTypeUid"
        findControlDisplayName="Find Account Type"
        [baseId]="baseId"
        [form]="form"
        [apFormGroup]="form"
        [formGroupSubmitted]="isSubmitted"
        [required]="getFindControlValidation('AccountTypeUid')"
        [singleSelect]="true"
        [findControlId]="FindControlIdService.ListAccountType"
        [(selectedPks)]="accountTypePks"
        (dirty)="accountTypeUidControl.markAsDirty()"
      >
      </ap-findcontrol>
    </div>
    <!-- Account Type Control end-->

    <!-- Fee Schedule Control start-->
    <div class="flex-item-two-columns form-group">
      <label
        for="{{ baseId }}-fee-schedule"
        class="radio-group-label"
      >
        <mat-radio-group
          class="radio-group"
          formControlName="UseProviderFeeSchedule"
        >
          <mat-radio-button
            id="{{ baseId }}-providers-fee-list"
            [value]="true"
            checked
            translate
          >Use Provider’s Fee
            List
          </mat-radio-button>
          <mat-radio-button
            id="{{ baseId }}-fee-list"
            [value]="false"
            class="fee-list"
            translate
          >Fee List
          </mat-radio-button>
        </mat-radio-group>
      </label>
      <ap-findcontrol
        id="{{ baseId }}-fee-schedule"
        controlName="FeeScheduleUid"
        findControlDisplayName="Find Fee Schedule"
        [baseId]="baseId"
        [form]="form"
        [apFormGroup]="form"
        [formGroupSubmitted]="!isFeeScheduleDisabled"
        [disabled]="isFeeScheduleDisabled"
        [required]="!isFeeScheduleDisabled"
        [singleSelect]="true"
        [findControlId]="findControlIdService.FeeSchedule"
        [(selectedPks)]="feeSchedulePks"
        (dirty)="feeScheduleUidControl.markAsDirty()"
      >
      </ap-findcontrol>
    </div>
    <!-- Fee Schedule Control end-->
  </div>

  <div class="flex-row-generic">
    <!-- Amount Allowed List Control start-->
    <div class="flex-item-two-columns form-group">
      <label for="{{ baseId }}-amount-allowed-list">Amount Allowed List</label>
      <ap-findcontrol
        id="{{ baseId }}-amount-allowed-list"
        controlName="AmountAllowedFeeScheduleUid"
        findControlDisplayName="Find Amount Allowed Schedule"
        [baseId]="baseId"
        [form]="form"
        [apFormGroup]="form"
        [formGroupSubmitted]="isSubmitted"
        [required]="getFindControlValidation('AmountAllowedFeeScheduleUid')"
        [singleSelect]="true"
        [findControlId]="findControlIdService.AmountAllowSchedule"
        [(selectedPks)]="allowedFeeSchedulePks"
        (dirty)="amountAllowedFeeScheduleUidControl.markAsDirty()"
      >
      </ap-findcontrol>
    </div>
    <!-- Amount Allowed List Control end-->

    <!-- Reimbursement Rule Control start-->
    <div class="flex-item-two-columns form-group">
      <label for="{{ baseId }}-reimbursement-rule">Reimbursement Rule</label>
      <ap-findcontrol
        id="{{ baseId }}-reimbursement-rule"
        controlName="ReimbursementRuleUid"
        findControlDisplayName="Find Reimbursement Rule Set"
        [baseId]="baseId"
        [form]="form"
        [apFormGroup]="form"
        [formGroupSubmitted]="isSubmitted"
        [required]="getFindControlValidation('ReimbursementRuleUid')"
        [singleSelect]="true"
        [findControlId]="findControlIdService.ListReimbursementRule"
        [(selectedPks)]="reimbursementRulePks"
        (dirty)="reimbursementRuleUidControl.markAsDirty()"
      >
      </ap-findcontrol>
    </div>
    <!-- Reimbursement Rule Control end-->
  </div>

  <div class="flex-row-generic">
    <!-- ERA Payer ID Control start-->
    <div class="flex-item-two-columns form-group">
      <label
        for="{{ baseId }}-era-payer-id"
        translate
      >ERA Payer ID</label>
      <input
        id="{{ baseId }}-era-payer-id"
        class="form-control"
        [ngClass]="{ error: showErrors(eraPayerIdControl, isSubmitted), 'required': isRequired(eraPayerIdControl) }"
        type="text"
        [maxlength]="fcListValidation.validations.ERAPayerID.MaxLength"
        formControlName="ERAPayerID"
      />
      <div
        *ngIf="showErrors(eraPayerIdControl, isSubmitted)"
        id="{{ baseId }}-warning-text-era-payer-id"
        class="incorrect-input"
        translate
      >
        {{ eraPayerIdControl.errors | fcListValidation : 'ERA Payer ID' }}
      </div>
    </div>
    <!-- ERA Payer ID Control end-->

    <!-- ERA Rule Group Control start-->
    <div class="flex-item-two-columns form-group">
      <label for="{{ baseId }}-era-rule-group">ERA Rule Group</label>
      <ap-findcontrol
        id="{{ baseId }}-era-rule-group"
        controlName="PrmRuleGroupUid"
        findControlDisplayName="Find Rule Group"
        [baseId]="baseId"
        [form]="form"
        [apFormGroup]="form"
        [formGroupSubmitted]="isSubmitted"
        [required]="getFindControlValidation('EraRuleGroupUid')"
        [singleSelect]="true"
        [findControlId]="findControlIdService.ListPrmRuleGroup"
        [(selectedPks)]="eraRuleGroupPks"
        (dirty)="eraRuleGroupUidControl.markAsDirty()"
      >
      </ap-findcontrol>
    </div>
    <!-- ERA Rule Group Control end-->
  </div>

  <div class="flex-row-generic lineup">
    <!-- Auto-writeoff Adj Type Control start-->
    <div class="flex-item-two-columns form-group">
      <label for="{{ baseId }}-auto-writeoff-adj-type">Auto-writeoff Adj Type</label>
      <ap-findcontrol
        id="{{ baseId }}-auto-writeoff-adj-type"
        controlName="AutoWriteoffCreditTypeUid"
        findControlDisplayName="Find Credit Types"
        [baseId]="baseId"
        [form]="form"
        [apFormGroup]="form"
        [findControlId]="findControlIdService.ListCreditType"
        [formGroupSubmitted]="isSubmitted"
        [required]="getFindControlValidation('AutoWriteoffCreditTypeUid')"
        [singleSelect]="true"
        (chipsChange)="onAutoWriteoffCreditTypeUidDataPopulate($event)"
        [(selectedPks)]="autoWriteoffCreditTypePks"
        (dirty)="autoWriteoffCreditTypeUidControl.markAsDirty()"
      >
      </ap-findcontrol>
    </div>
    <!-- Auto-writeoff Adj Type Control end-->

    <!-- No Network checkbox start-->
    <div class="checkbox-group flex-item-two-columns modal-checkboxes">
      <mat-checkbox
        id="{{ baseId }}-no-network-checkbox"
        class="no-network-checkbox"
        formControlName="NoNetwork"
        translate
      > No Network
      </mat-checkbox>
    </div>
    <!-- No Network checkbox end-->
  </div>

  <div class="flex-row-generic">
    <!-- Eligibility ClearingHouse Control start-->
    <div class="flex-item-two-columns form-group">
      <label for="{{ baseId }}-eligibility-clearinghouse">Eligibility Clearinghouse</label>
      <ap-findcontrol
        id="{{ baseId }}-eligibility-clearinghouse"
        controlName="EligibilityClearingHouseUid"
        findControlDisplayName="Find ClearingHouse"
        [baseId]="baseId"
        [form]="form"
        [apFormGroup]="form"
        [formGroupSubmitted]="isSubmitted"
        [required]="getFindControlValidation('EligibilityClearingHouseUid')"
        [singleSelect]="true"
        [(selectedPks)]="eligibilityClearingHousePks"
        [findControlId]="findControlIdService.ListClaimClearingHouse"
        (dirty)="eligibilityClearingHouseUidControl.markAsDirty()"
      >
      </ap-findcontrol>
    </div>
    <!-- Eligibility ClearingHouse Control end-->

    <!-- Eligibility Payer Control start-->
    <div class="flex-item-two-columns form-group">
      <label for="{{ baseId }}-eligibility-payer">Eligibility Payer</label>
      <ap-findcontrol
        id="{{ baseId }}-eligibility-payer"
        controlName="EligibilityPayerUid"
        findControlDisplayName="Find Electronic Payer"
        [baseId]="baseId"
        [form]="form"
        [apFormGroup]="form"
        [formGroupSubmitted]="isSubmitted || isEligibilityPayerFindControlRequired"
        [required]="isEligibilityPayerFindControlRequired"
        [singleSelect]="true"
        [(selectedPks)]="eligibilityPayerPks"
        [findControlId]="findControlIdService.ViewClearinghouseInactive"
        (dirty)="eligibilityPayerUidControl.markAsDirty()"
      >
      </ap-findcontrol>
    </div>
    <!-- Eligibility Payer Control end-->
  </div>

  <div class="flex-row-generic">
    <!-- Eligibility Format Control start-->
    <div class="flex-item-two-columns form-group">
      <label for="{{ baseId }}-eligibility-format">Eligibility Format</label>
      <ap-findcontrol
        id="{{ baseId }}-eligibility-format"
        controlName="EligibilityFormatUid"
        findControlDisplayName="Find Claim Format"
        [baseId]="baseId"
        [form]="form"
        [apFormGroup]="form"
        [formGroupSubmitted]="isSubmitted"
        [required]="getFindControlValidation('Eligibility_ListClaimFormatUid')"
        [singleSelect]="true"
        [findControlId]="FindControlIdService.ListClaimFormat"
        [(selectedPks)]="eligibilityFormatPks"
        (dirty)="eligibilityFormatUidControl.markAsDirty()"
      >
      </ap-findcontrol>
    </div>
    <!-- Eligibility Format Control end-->

    <!-- Enrollment ClearingHouse Control start-->
    <div class="flex-item-two-columns form-group">
      <label for="{{ baseId }}-enrollment-clearinghouse">Enrollment Clearinghouse</label>
      <ap-findcontrol
        id="{{ baseId }}-enrollment-clearinghouse"
        controlName="EnrollmentClearingHouseUid"
        findControlDisplayName="Find Enrollment ClearingHouse"
        [baseId]="baseId"
        [form]="form"
        [apFormGroup]="form"
        [formGroupSubmitted]="isSubmitted"
        [required]="getFindControlValidation('EnrollmentClearingHouseUid')"
        [singleSelect]="true"
        [findControlId]="findControlIdService.ListEnrollmentClearingHouse"
        [(selectedPks)]="enrollmentClearingHousePks"
        (dirty)="enrollmentClearingHouseUidControl.markAsDirty()"
      >
      </ap-findcontrol>
    </div>
    <!-- Enrollment ClearingHouse Control end-->
  </div>

  <div class="flex-row-generic">
    <!-- Demographics ClearingHouse Control start-->
    <div class="flex-item-two-columns form-group">
      <label for="{{ baseId }}-demographics-clearinghouse">Demographics Clearinghouse</label>
      <ap-findcontrol
        id="{{ baseId }}-demographics-clearinghouse"
        controlName="DemographicsClearingHouseUid"
        findControlDisplayName="Find Demographics ClearingHouse"
        [baseId]="baseId"
        [form]="form"
        [apFormGroup]="form"
        [formGroupSubmitted]="isSubmitted"
        [required]="getFindControlValidation('DemographicsClearingHouseUid')"
        [singleSelect]="true"
        [findControlId]="findControlIdService.ListDemographicsClearingHouse"
        [(selectedPks)]="demographicsClearingHousePks"
        (dirty)="demographicsClearingHouseUidControl.markAsDirty()"
      >
      </ap-findcontrol>
    </div>
    <!-- Demographics ClearingHouse Control end-->

    <!-- alternate Insurance Plan Control start-->
    <div class="flex-item-two-columns form-group">
      <label for="{{ baseId }}-alternate-insurance-plan">Alternate Insurance Plan</label>
      <ap-findcontrol
        id="{{ baseId }}-alternate-insurance-plan"
        controlName="AlternateInsurancePlanUid"
        findControlDisplayName="Find Insurance Plan"
        [baseId]="baseId"
        [form]="form"
        [apFormGroup]="form"
        [formGroupSubmitted]="isSubmitted"
        [required]="getFindControlValidation('AlternateInsurancePlanUid')"
        [singleSelect]="true"
        [findControlId]="FindControlIdService.ViewPayerPlan"
        [(selectedPks)]="alternateInsurancePlanPks"
        (dirty)="alternateInsurancePlanUidControl.markAsDirty()"
      >
      </ap-findcontrol>
    </div>
    <!-- alternate Insurance Plan Control end-->
  </div>

  <div class="flex-row-generic">
    <!-- ICD-10 Start Date Control start-->
    <div class="flex-item-two-columns form-group">
      <ap-datepicker-next-prev
        id="{{ baseId }}-icd"
        labelName="ICD-10 Start Date"
        [baseId]="baseId"
        [selectedDate]="icdControl.value"
        (selectedChanged)="onCalendarDateChangeIcd($event)"
      >
      </ap-datepicker-next-prev>
    </div>
    <!-- ICD-10 Start Date Control end-->

    <!-- EM 2021/2023 Start Date Control start-->
    <div class="flex-item-two-columns form-group">
      <ap-datepicker-next-prev
        id="{{ baseId }}-em"
        labelName="EM 2021/2023 Start Date"
        [baseId]="baseId"
        [selectedDate]="emControl.value"
        (selectedChanged)="onCalendarDateChangeEm($event)"
      >
      </ap-datepicker-next-prev>
    </div>
    <!-- EM 2021/2023 Start Date Control end-->
  </div>

  <!-- Checkboxes start-->
  <div class="checkbox-group">
    <mat-checkbox
      id="{{ baseId }}-requires-a-referral-checkbox"
      [formControl]="referralRequiredControl"
      translate
    >
      Requires a Referral
    </mat-checkbox>
    <mat-checkbox
      id="{{ baseId }}-ccm-cpo-eligible-payer-checkbox"
      [formControl]="eligiblePayerControl"
      translate
    >
      CCM/BHI/CPO Eligible Payer
    </mat-checkbox>
    <mat-checkbox
      id="{{ baseId }}-map-to-payer-type-code-checkbox"
      [formControl]="mapToPayerTypeCodeControl"
      translate
    >
      Map to Payer Type Code
    </mat-checkbox>
  </div>
  <!-- Checkboxes end-->

  <hr />
  <!-- Require ABN Validation checkbox start-->
  <div class="checkbox-group">
    <mat-checkbox
      id="{{ baseId }}-require-abn-validation-checkbox"
      [formControl]="requiresAbnCheckingControl"
      translate
    >
      Require ABN Validation
    </mat-checkbox>
  </div>
  <!-- Require ABN Validation checkbox end-->

  <div class="flex-row-generic">
    <!-- ABN English Format Control start-->
    <div class="flex-item-two-columns form-group">
      <label for="{{ baseId }}-abn-english-format">ABN English Format</label>
      <ap-findcontrol
        id="{{ baseId }}-abn-english-format"
        controlName="EnglishFormattingTemplateUid"
        findControlDisplayName="Find Formatting Model"
        [baseId]="baseId"
        [form]="form"
        [apFormGroup]="form"
        [formGroupSubmitted]="isSubmitted || requiresAbnCheckingControl.value"
        [required]="isEnglishFormattingTemplateRequired"
        [disabled]="!requiresAbnCheckingControl.value"
        [singleSelect]="true"
        [findControlId]="findControlIdService.ListFormattingTemplate"
        [(selectedPks)]="englishFormattingTemplatePks"
        (dirty)="englishFormattingTemplateUidControl.markAsDirty()"
      >
      </ap-findcontrol>
    </div>
    <!-- ABN English Format Control end-->

    <!-- ABN Spanish Format Control start-->
    <div class="flex-item-two-columns form-group">
      <label for="{{ baseId }}-abn-spanish-format">ABN Spanish Format</label>
      <ap-findcontrol
        id="{{ baseId }}-abn-spanish-format"
        controlName="SpanishFormattingTemplateUid"
        findControlDisplayName="Find Formatting Model"
        [baseId]="baseId"
        [form]="form"
        [apFormGroup]="form"
        [formGroupSubmitted]="isSubmitted || requiresAbnCheckingControl.value"
        [required]="isSpanishFormattingTemplateRequired"
        [disabled]="!requiresAbnCheckingControl.value"
        [singleSelect]="true"
        [findControlId]="findControlIdService.ListFormattingTemplate"
        [(selectedPks)]="spanishFormattingTemplatePks"
        (dirty)="spanishFormattingTemplateUidControl.markAsDirty()"
      >
      </ap-findcontrol>
    </div>
    <!-- ABN Spanish Format Control end-->
  </div>
</div>
